import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditDepartmentTeamsReady} from '../redux/departmentTeams'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'



import {Cities} from '../../../common/DropDowns/index'

import {Departments,Employees} from './DropDowns/index'
//import * as Helpers from '../../../common/helpers'

class AddEditDepartmentTeams extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        departmentTeamsName: "",
        department: "",
        head: "",
        cityId:"",

        departmentTeamsNameErrorText: false,
        departmentTeamsNameErrorData: '',

        departmentErrorText: false,
        departmentErrorData: '',

        headErrorText: false,
        headErrorData: '',

        cityIdErrorText: false,
        cityIdErrorData: '',

        subTitle: Constants.ADD_DEPARTMENT_TEAM

    }

    this.isComponentStillMounted = true

    this.departmentTeamsNameComponent = null
    this.departmentTeamsNameSection = null

    this.departmentComponent = null
    this.departmentSection = null


    this.headComponent = null
    this.headSection = null

    this.cityIdComponent = null
    this.cityIdSection = null



}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditDepartmentTeamsReady(false))

    if (this.props.departmentTeams && this.props.departmentTeams.departmentTeamsSelectedId && this.props.departmentTeams.departmentTeamsSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_DEPARTMENT_TEAM))
        this.setState({
            subTitle: "Edit Team",
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_DEPARTMENT_TEAM))
        this.setState({
            subTitle: "Add Team"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    if (this.props.departmentTeams && this.props.departmentTeams.departmentTeamsSelectedId && this.props.departmentTeams.departmentTeamsSelectedId !== null) {
        this.getDepartmentTeamsById(this.props.departmentTeams.departmentTeamsSelectedId)
    }else{

    this.props.dispatch(addEditDepartmentTeamsReady(true))
    }
}

componentDidMount() {

        this.departmentTeamsNameSection = ReactDOM.findDOMNode(this.refs.departmentTeamsNameSection)

        this.departmentSection = ReactDOM.findDOMNode(this.refs.departmentSection)

        this.headSection = ReactDOM.findDOMNode(this.refs.headSection)

        this.cityIdSection = ReactDOM.findDOMNode(this.refs.cityIdSection)



}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addEditDepartmentTeamsReady(false))
    let data = {}

    let departmentTeamsNameObject = this.mandateValidation("departmentTeamsName", Constants.FORM_INPUT)
    if (departmentTeamsNameObject.status) {
        data.name = this.departmentTeamsNameComponent.value
    } else {

         this.props.dispatch(addEditDepartmentTeamsReady(true))
        return
    }

    let departmentObject = this.mandateValidation("department", Constants.FORM_SELECT)
    if (departmentObject.status) {
        data.department_id = this.departmentComponent.value
    } else {
        this.props.dispatch(addEditDepartmentTeamsReady(true))
        return
    }


    let headObject = this.mandateValidation("head", Constants.FORM_SELECT)
    if (headObject.status) {
        data.team_head_id = this.headComponent.value
    } else {
        this.props.dispatch(addEditDepartmentTeamsReady(true))
        return
    }



    let cityIdObject = this.mandateValidation("cityId", Constants.FORM_SELECT)
    if (cityIdObject.status) {
        data.city_id = this.cityIdComponent.value
    } else {
        this.props.dispatch(addEditDepartmentTeamsReady(true))
        return
    }



    let apiPayloadData=data;


    if(this.state.editFlag){


        apiService.editDepartmentTeams(apiPayloadData,this.state.departmentTeamsData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditDepartmentTeamsReady(true))
                        this.props.history.push("/dashboard/department/teams/list")
                    } else {

                        this.props.dispatch(addEditDepartmentTeamsReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditDepartmentTeamsReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addDepartmentTeams(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditDepartmentTeamsReady(true))
                        this.props.history.push("/dashboard/department/teams/list")
                    } else {

                        this.props.dispatch(addEditDepartmentTeamsReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditDepartmentTeamsReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getDepartmentTeamsById = (id) => {
    apiService.getDepartmentTeamsById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        departmentTeamsData: responseData.data,
                        departmentTeamsName : responseData.data.name,
                        department : responseData.data.department.id,
                        head : responseData.data.team_head.id,
                        cityId : responseData.data.city_id               
                    })

                    if (this.isComponentStillMounted) {
                        this.departmentTeamsNameComponent.value=responseData.data.name
                        this.departmentComponent.value=responseData.data.department.id
                        this.cityIdComponent.value=responseData.data.city_id 
                        this.headComponent.value=responseData.data.team_head.id 
                    }

                    this.props.dispatch(addEditDepartmentTeamsReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditDepartmentTeamsReady(true))
        })
}




 departmentChange = (data) => {
    this.departmentComponent.value=data.value
        this.setState({
            department :data.value,
            departmentErrorText: false,
            departmentErrorData: ''
        })
        this.departmentSection.className= this.departmentSection.className.replace(" has-error", "")
    }



 employeeChange = (data) => {
    this.headComponent.value=data.value
        this.setState({
            head :data.value,
            headErrorText: false,
            headErrorData: ''
        })
        this.headSection.className= this.headSection.className.replace(" has-error", "")
    }

    




    cityChange = (data) => {
       this.cityIdComponent.value=data.value
        this.setState({
            cityId :data.value,
            cityIdErrorText: false,
            cityIdErrorData: ''
        })
        this.cityIdSection.className= this.cityIdSection.className.replace(" has-error", "")
    }





    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.departmentTeamsNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Team Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Team Name" type="text" ref={el => this.departmentTeamsNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("departmentTeamsName")}} />
                                                        <span className="help-block"style={{display: this.state.departmentTeamsNameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.departmentTeamsNameErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.departmentSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Department *</label>
                                                    <div className="col-sm-9" ref={el => this.departmentComponent = el}>
                                                        
                                                         <Departments departmentChange={this.departmentChange} selectedValue={this.state.department} />

                                                        <span className="help-block"style={{display: this.state.departmentErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.departmentErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.headSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Team Head *</label>
                                                    <div className="col-sm-9" ref={el => this.headComponent = el}>
                                                        
                                                         <Employees employeeChange={this.employeeChange} selectedValue={this.state.head} />

                                                        <span className="help-block"style={{display: this.state.headErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.headErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el => this.cityIdSection = el}>
                                                            <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City *</label>
                                                            <div className="col-sm-9" ref={el => this.cityIdComponent = el}>
                                                                
                                                                 <Cities cityChange={this.cityChange} selectedValue={this.state.cityId} />

                                                                <span className="help-block"style={{display: this.state.cityIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                                    {this.state.cityIdErrorData}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </div>

                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        departmentTeams: state.departmentTeams,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditDepartmentTeams))


// WEBPACK FOOTER //
// ./src/modules/Department Teams/Components/AddEditDepartmentTeams.js